<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <b-col lg="12" sm="12" class="text-left">
            <lg-form-input invalidFeedback="Informe um perfil válida!" description=" " :error="$v.form.perfil"
              v-model="form.perfil" label="Perfil:*" />
          </b-col>

          <b-col lg="12" sm="12" class="text-left">
            <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" " :error="$v.form.descricao"
              v-model="form.descricao" label="Descrição:*" />
          </b-col>

          <b-col lg="12" sm="12" class="text-left">
            <lg-form-const-select :disabled="id != null" v-model="form.sistema" label="Sistema:*" :options="form.sistemas" textField="nome"
              valueField="id" />
          </b-col>
        </b-form-row>

        <b-form-group label="Status:*" class="ml-3">
          <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
            name="status-inline"></b-form-radio-group>
        </b-form-group>


        <b-form-row>

          <b-col cols="3"></b-col>
          <b-col cols="6" class="text-center">
            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
              <b-icon icon="check-circle" />
              <b-tooltip target="salvar" title="Salvar"></b-tooltip>

            </b-button>

            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
              <b-icon icon="x-circle" />
              <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

            </b-button>
          </b-col>
          <b-col cols="3"></b-col>

        </b-form-row>


      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
  },
  props: {
    id: {
        type:Number,
        default: null
    },
    prefix: {
      type: String,
      default: "",
    },

  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      perfil: { required },
      descricao: { required },
      sistema: { required },
      situacao: { required },
    },
  },

  data() {
    return {
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],

      title: "Cadastro",
      showModal: true,
      form: {
        situacao: 1,
        descricao: "",
        perfil: "",

        sistema: null,
        sistemas: [],
      },
    };
  },

  async beforeMount() {
    this.$service = new ResourceService(`/api/sgu/sistemas/perfis`);
    this.$serviceSistema = new ResourceService("/api/sgu/sistemas");
  },

  async mounted() {
    this.buscarSistemas();
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = {
        ...this.form,
        ...data,
      };
      this.form.sistema = this.form.sistema.id;
    } else {
      this.form.situacao = 1;
    }
  },

  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
        });
        return;
      }
      await this.$saveResource(this.form, "", false);
      this.cancelar();
    },

    async buscarSistemas() {
      const result = await this.$serviceSistema.findAll({});
      this.form.sistemas = result.data.content;
    },
    cancelar() {
      this.$emit("close");
    },

  },
};
</script>
